import axios from 'axios'
import React, { useState } from 'react'

import { AppButton } from '../utils'
import { Linkedin, Instagram, Twitter, Youtube } from './ButtonLinks'

function ContactUs(props) {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()

    axios
      .post(
        'https://sheet.best/api/sheets/3e3a7e00-d461-4a80-8282-750ee7b90eb0',
        formData
      )
      .then(() => {
        console.log('Submitted')
        setFormData({ name: '', phone: '', email: '', message: '' })
      })
  }
  return (
    <div className='px-12 max-w-7xl mx-auto mt-32 mb-28'>
      <div className='flex flex-col items-center justify-center mb-4'>
        <h1 className='font-semibold font-josefin text-5xl md:text-7xl text-center text-mix-400 mb-8 md:mb-16'>
          Contact Us
        </h1>
        <p className='pt-2 font-montserrat text-gray-600 text-center'>
          Feel free to reach us anytime! We'll be more than happy to help
        </p>
      </div>
      <div className='flex flex-col sm:flex-row sm:space-x-4 justify-between items-center sm:items-start h-full'>
        <div className='flex flex-col items-center sm:items-start justify-evenly font-montserrat text-center sm:text-left pt-10 space-y-4'>
          <div>
            <h3 className='text-mix-400 font-semibold text-base md:text-lg lg:text-xl'>
              Address
            </h3>
            <p className='text-base'>
              BPIT, PSP-4, Dr KN Katju Marg, Sector 17, Rohini, Delhi 110089
            </p>
          </div>
          <div>
            <h3 className='text-mix-400 font-semibold text-base md:text-lg lg:text-xl'>
              Email
            </h3>
            <p className='text-base'>drishtibpit@gmail.com</p>
            {/* <p>support@drishti.com</p> */}
          </div>
          <div>
            <h3 className='text-mix-400 font-semibold text-base md:text-lg lg:text-xl'>
              Follow Us
            </h3>
            <p className='py-2 text-xs text-gray-600'>
              See us in action on these platforms
            </p>
            <div className='flex space-x-4 flex align-center mt-4 mx-10 sm:mx-0'>
              <Instagram size={30} />
              <Twitter size={30} />
              <Youtube size={30} />
              <Linkedin size={30} />
            </div>
          </div>
        </div>
        <div className='flex flex-col items-center sm:items-start justify-evenly pt-10 text-center sm:text-left'>
          <div>
            <h3 className='text-mix-400 font-semibold font-montserrat text-base md:text-lg lg:text-xl'>
              Phone
            </h3>
            <p className='text-base font-josefin'>+91 79732-58997</p>
            <p className='text-base font-josefin'>+91 99112-55903</p>
          </div>
        </div>
        <div className='w-full md:w-3/4 lg:w-1/3'>
          <form
            onSubmit={handleSubmit}
            className='flex flex-col items-center sm:items-start justify-evenly pt-10 h-full space-y-8 font-montserrat'
          >
            <div className='w-full'>
              <label
                className='font-semibold text-base md:text-lg lg:text-xl text-mix-400 px-3'
                htmlFor='name'
              >
                Name
              </label>
              <input
                className='w-full border-none rounded-full outline-none focus:ring-2 focus:outline-none focus:ring-mix-200 px-4 h-10 text-sm sm:text-lg'
                id='name'
                type='text'
                placeholder='Enter your Name'
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
            </div>
            <div className='w-full'>
              <label
                className='font-semibold text-base md:text-lg lg:text-xl text-mix-400 px-3'
                htmlFor='phone'
              >
                Phone Number
              </label>
              <input
                className='w-full border-none rounded-full outline-none focus:ring-2 focus:outline-none focus:ring-mix-200 px-4 h-10 text-sm sm:text-lg'
                id='phone'
                type='text'
                placeholder='Enter your phone number'
                value={formData.phone}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
              />
            </div>
            <div className='w-full'>
              <label
                className='font-semibold text-base md:text-lg lg:text-xl text-mix-400 px-3'
                htmlFor='email'
              >
                Email
              </label>
              <input
                className='w-full border-none rounded-full outline-none focus:ring-2 focus:outline-none focus:ring-mix-200 px-4 h-10 text-sm sm:text-lg'
                id='email'
                type='email'
                placeholder='Enter your email'
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
              />
            </div>
            <div className='w-full'>
              <label
                className='font-semibold text-lg text-mix-400 px-3'
                htmlFor='message'
              >
                Message
              </label>
              <textarea
                className='w-full border-none rounded-3xl outline-none focus:ring-2 focus:outline-none focus:ring-mix-200 px-4 py-4 text-xs sm:text-lg'
                id='message'
                type='text'
                placeholder='Enter your message'
                value={formData.message}
                onChange={(e) =>
                  setFormData({ ...formData, message: e.target.value })
                }
              />
            </div>
            <AppButton text='Submit' />
          </form>
        </div>
      </div>
    </div>
  )
}

export default ContactUs
